export type RewardType = "none" | "subscription_box";

export const rewardTypes: RewardType[] = ["none", "subscription_box"];

export const selectRewardTypes = rewardTypes.map((rewardType) => ({
  value: rewardType,
  label: rewardType.toUpperCase().replaceAll("_", " "),
}));
